export const getFormattedTime = (): string => {
  const currentDate = new Date();
  const timezoneOffset = -currentDate.getTimezoneOffset();
  const dif = timezoneOffset >= 0 ? "+" : "-";
  const pad = (num: number) => {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? "0" : "") + String(norm);
  };
  return `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(
    currentDate.getDate()
  )}T${pad(currentDate.getHours())}:${pad(currentDate.getMinutes())}:${pad(
    currentDate.getSeconds()
  )}${dif}${pad(timezoneOffset / 60)}:${pad(timezoneOffset % 60)}`;
};
export const generateId = (artId: string, filename: string) => {
  function hash(a: number) {
    const result = (a * 2654435761) % Math.pow(2, 32);
    let resultStr = result.toString().substr(0, 10);
    while (resultStr.length < 10) {
      resultStr += "0";
    }
    return resultStr;
  }
  function random() {
    return Math.floor(Math.random() * Math.pow(10, 16));
  }

  const combinedNumber = Number(artId + filename) || 0;

  return "000000" + random().toString() + hash(combinedNumber);
};
